

import pdf from "@/assets/img/logos/pdf.png";
import word from "@/assets/img/logos/word.png";
import excelLogo from "@/assets/img/logos/excel.jpg";

function installVueGlobal(Vue, globalName, globalValue) {
  const globalPrototype = Vue.version.slice(0, 2) === '3.' ? Vue.config.globalProperties : Vue.prototype;

  // Don't use Object.assign() to match the Vue.js supported browsers (ECMAScript 5)
  globalPrototype[globalName] = globalValue;
}

const mapper = {
  excelFiles: {
    formats: [
      '.xlsx', '.xlsm', '.xlsb', '.xltx', '.xltm',
      '.xlt', '.xml', '.xlam', '.xla', '.xlw', '.xlr', '.xls', '.csv'
    ],
    logo: excelLogo
  },
  pdfFiles: {
    formats: ['.pdf'],
    logo: pdf
  },
  wordFiles: {
    formats: [
      '.doc',
      '.docm',
      '.docx',
      '.dot',
      '.dotm',
      '.dotx',
      '.htm',
      '.html',
      '.mht',
      '.mhtml',
      '.odt',
      '.rtf',
      '.wps',
      '.xml',
    ],
    logo: word
  },
}


// eslint-disable-next-line no-unused-vars
export default function install(Vue, options={}) {
  installVueGlobal(Vue, '$resourceMapper', mapper);
}